import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Global from './utils/global.js';
import './icons'; // 引入svg icon

import '@/utils/permission.js';

// import './utils/directive.js';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN'; // lang i18n
// import '@/styles/theme/index.css'; // theme css

import '@/styles/index.scss'; // global css
import VueQuillEditor from 'vue-quill-editor';
Vue.use(VueQuillEditor);
import VueAMap from 'vue-amap';
Vue.use(VueAMap);

import 'quill/dist/quill.snow.css'; // 富文本编辑器外部引用样式  三种样式三选一引入即可
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.bubble.css';

Vue.use(ElementUI, { locale, size: 'medium' });

Vue.config.productionTip = false;

import Print from './plugins/print/Print';
Vue.use(Print);

Vue.prototype.$global = Global;

import util from '@/utils/index.js';
Vue.prototype.$util = util;

// 设置组件标签
import customComponents from '@/utils/custom-component.js';
Vue.use(customComponents);

import xss from 'xss';
Vue.prototype.xss = xss;

VueAMap.initAMapApiLoader({
  key: '0daa74cdff5e194b7f86135a778267cc',
  plugin: [
    'AMap.Autocomplete', // 输入提示插件
    'AMap.PlaceSearch', // POI搜索插件
    'AMap.Scale', // 右下角缩略图插件 比例尺
    'AMap.OverView', // 地图鹰眼插件
    'AMap.ToolBar', // 地图工具条
    'AMap.MapType', // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    'AMap.PolyEditor', // 编辑 折线多，边形
    'AMap.CircleEditor', // 圆形编辑器插件
    'AMap.Geocoder', // 地址服务
    'AMap.Geolocation' // 定位控件，用来获取和展示用户主机所在的经纬度位置
  ],
  // uiVersion: '1.0', // ui库版本，不配置不加载,
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
import filters from '@/utils/filters.js';
// 注册全局fileter
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

new Vue({
  router,
  store,
  beforeCreate() {
    Vue.prototype.$EventBus = this;
  },
  render: h => h(App)
}).$mount('#app');
